import React, { useMemo, useState } from "react";
import { useProfileParams } from "../../../../../../utils/common";
import KPITile from "../../../../../common/KPITile/KPITile";
import KPIDetailTile from "../../../../../common/KPIDetailTile/KPIDetailTile";
import DonutChart, {
  DonutChartSegment,
} from "../../../../../common/DonutChart/DonutChart";
import styles from "../../../LegAnalysis/structure/QMix/QMixTile.module.scss";
import InsightAI from "../../../../../common/InsightAI/InsightAI";
import { useTranslation } from "react-i18next";
import ViewModeSwitcher, {
  ViewMode,
} from "../../../../../common/ViewModeSwitcher/ViewModeSwitcher";
import Skeleton from "../../../../../common/Skeleton/Skeleton";
import isEmpty from "lodash/isEmpty";
import GenericTable from "../../../../../common/GenericTable/GenericTable";
import CategoryPerformanceView from "../../Shared/CategoryPerformanceView/CategoryPerformanceView";
import StackedGroupedBarChart from "../../../../../common/GroupedStackedBarChart/GroupedStackedBarChart";
import { useAppSelector } from "../../../../../../redux/hooks";

interface SummaryProp {
  summary?: any;
  loading?: boolean;
}

// ---- Monthly Mock data for accordian table ---- //
const businessLineMonthly = {
  kpiCode: "business-line",
  detail: {
    chart: {
      chartSummary: {
        kpiValue: 0,
        kpiDataType: "number",
      },
      chartDetail: {
        lineChartDetail: null,
        stackedBarChartDetail: [
          {
            label: "PY 21",
            segments: [
              { label: "Core Plan Income", value: 300 },
              { label: "Core Plus Income", value: 500 },
              { label: "Retail Profit", value: 400 },
            ],
          },
          {
            label: "PY 22",
            segments: [
              { label: "Core Plan Income", value: 300 },
              { label: "Core Plus Income", value: 550 },
              { label: "Retail Profit", value: 600 },
            ],
          },
          {
            label: "PY 23",
            segments: [
              { label: "Core Plan Income", value: 200 },
              { label: "Core Plus Income", value: 300 },
              { label: "Retail Profit", value: 550 },
            ],
          },
          {
            label: "PY 24",
            segments: [
              { label: "Core Plan Income", value: 600 },
              { label: "Core Plus Income", value: 300 },
              { label: "Retail Profit", value: 100 },
            ],
          },
          {
            label: "PY 25 (YTD)",
            segments: [
              { label: "Core Plan Income", value: 500 },
              { label: "Core Plus Income", value: 700 },
              { label: "Retail Profit", value: 800 },
            ],
          },
        ],
        tableDetail: {
          header: {
            row: [
              { kpiValue: "Sub Category" },
              { kpiValue: "Sep" },
              { kpiValue: "Oct" },
              { kpiValue: "Nov" },
              { kpiValue: "Dec" },
              { kpiValue: "Jan" },
              { kpiValue: "Feb" },
              { kpiValue: "Mar" },
              { kpiValue: "Apr" },
              { kpiValue: "May" },
              { kpiValue: "Jun" },
              { kpiValue: "Jul" },
              { kpiValue: "Aug" },
            ],
          },
          body: {
            rows: [
              [
                {
                  kpiValue: "Beauty",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Durables",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 9456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Home Care",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Nutrition",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Personal Care",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Catelog",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Other",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
              [
                {
                  kpiValue: "Unknown",
                  kpiDataType: "string",
                  children: [
                    [
                      {
                        kpiValue: "PY 25($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 25(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 2456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24($)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },

                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 1456,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                    [
                      {
                        kpiValue: "PY 24(BV)",
                        kpiDataType: "string",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                      {
                        kpiValue: 3987,
                        kpiDataType: "currency",
                        kpiCurrency: "USD",
                      },
                    ],
                  ],
                },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
                { kpiValue: "", kpiDataType: "" },
              ],
            ],
          },
        },
      },
    },
  },
  kpiCurrency: "USD",
};

// ---- Yearly Mock data stacked chart (empty) ---- //
const BusinessMockDetailYearly = {
  kpiCode: "business-line",
  detail: {
    chart: {
      chartSummary: {
        kpiValue: 0,
        kpiDataType: "number",
      },
      chartDetail: {
        stackedBarChartDetail: {
          years: ["PY 21", "PY 22", "PY 23", "PY 24", "PY 25(YTD)"],
          categories: {
            beauty: { label: "Beauty", budget: [44000, 55000, 41000, 67000, 22000, 43000, 34000, 40000], bv: [42000, 52000, 40000, 64000, 21000, 41000, 34000, 40000], },
            catalog: { label: "Catalog", budget: [28000, 30000, 27000, 35000, 29000, 33000, 34000, 40000], bv: [26000, 29000, 25000, 33000, 27000, 31000, 34000, 40000], },
            durables: { label: "Durables", budget: [15000, 18000, 17000, 21000, 16000, 19000, 34000, 40000], bv: [14000, 17000, 16000, 20000, 15000, 18000, 34000, 40000], },
            nutrition: { label: "Nutrition", budget: [20000, 23000, 21000, 26000, 24000, 27000, 34000, 40000], bv: [19000, 22000, 20000, 25000, 23000, 26000, 34000, 40000], },
            personalCare: { label: "Personal Care", budget: [14500, 15500, 15000, 16500, 16000, 17000, 34000, 40000], bv: [13500, 14500, 14000, 15500, 15000, 16000, 34000, 40000], },
            homeCare: { label: "Home Care", budget: [12000, 14000, 13000, 16000, 15000, 17000, 34000, 40000], bv: [11000, 13000, 12000, 15000, 14000, 16000, 34000, 40000], },
            other: { label: "Other", budget: [6500, 7000, 6800, 7500, 7200, 7800, 34000, 40000], bv: [6000, 6500, 6300, 7000, 6700, 7200, 34000, 40000], },
            skinCare: { label: "Skin Care", budget: [6500, 7000, 6800, 7500, 7200, 7800, 34000, 40000], bv: [6000, 6500, 6300, 7000, 6700, 7200, 34000, 40000], },
            unknown: { label: "Unknown", budget: [6500, 7000, 6800, 7500, 7200, 7800, 34000, 40000], bv: [6000, 6500, 6300, 7000, 6700, 7200, 34000, 40000], }
          }
        },
        tableDetail: {
          header: {
            row: [
              { kpiValue: "Year" },
              { kpiValue: "YOY Change ($)" },
              { kpiValue: "Yearly Total ($)" },
              { kpiValue: "YOY Change (BV)" },
              { kpiValue: "Yearly Total (BV)" }
            ],
          },
          body: {
            rows: [
              [
                {
                  kpiValue: "Beauty", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 20, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 70, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2345, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 70, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2345, kpiDataType: "currency", kpiCurrency: "USD" },
              ],
              [
                {
                  kpiValue: "Durables", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 54, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 54, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: -12, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: -12, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 54, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 54, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: -12, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: -12, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: -34, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: -34, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
              [
                {
                  kpiValue: "Home Care", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
              [
                {
                  kpiValue: "Nutrition", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
              [
                {
                  kpiValue: "Personal Care", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
              [
                {
                  kpiValue: "Catalog", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
              [
                {
                  kpiValue: "Other", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
              [
                {
                  kpiValue: "Unknown", kpiDataType: "string",
                  children: [
                    [
                      { kpiValue: "PY25 (YTD)", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: -10, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" }
                    ],
                    [
                      { kpiValue: "PY24", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY23", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [
                      { kpiValue: "PY22", kpiDataType: "string", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                      { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                      { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ],
                    [{ kpiValue: "PY21", kpiDataType: "string", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    { kpiValue: 24, kpiDataType: "percentage", kpiCurrency: "USD" },
                    { kpiValue: 3004, kpiDataType: "currency", kpiCurrency: "USD" },
                    ]
                  ]
                },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },
                { kpiValue: 23, kpiDataType: "percentage", kpiCurrency: "USD" },
                { kpiValue: 2456, kpiDataType: "currency", kpiCurrency: "USD" },

              ],
            ],
          },
        },
      },
    },
  },
  kpiCurrency: "USD",
};
export const BusinessLine: React.FC<SummaryProp> = ({
  summary,
  loading = false,
}) => {
  // Display API-provided segments when available; otherwise show nothing (0 fallback is implicit per segment values)
  const segments: DonutChartSegment[] = Array.isArray(summary?.segments)
    ? summary!.segments
    : [];
  const { t } = useTranslation();

  return (
    <KPITile
      title={t("business_line")}
      dataTestId="business-line-tile"
      loading={loading}
      className={styles.center_content}
    >
      <div className={styles.tile_content}>
        <DonutChart
          size={125}
          strokeWidth={20}
          legendGap={24}
          segments={segments}
          showLegend
          isPortfolio
        />
      </div>
    </KPITile>
  );
};

// ---- Sub-components for Views ---- //
interface BusinessLineMonthlyViewProps {
  tableData: any;
  kpiCode: string;
}

type Theme = "light" | "dark";

const ALL_PILL_COLOR: Record<Theme, string> = {
  light: "#1677FF",
  dark: "#69B1FF"
};

/* ================= THEME CONFIG ================= */
const CATEGORY_COLORS: Record<Theme, string[]> = {
  light: ["#99B2F5", "#F16A81", "#77CBBF", "#667DBB", "#B2F9FF", "#AF60B1", "#77CBBF", "#F5A066", "#CE4800"],
  dark: ["#5969D6", "#F3596C", "#396E75", "#38539A", "#05A896", "#7E3E80", "#396E75", "#F5A066", "#EF6D46"]
};
// TODO: Remove after validation
/*
// dark
data vis/color-viz-series-01 - #99B2F5 - Beauty
data vis/color-viz-series-02 - #F16A81 - Other
data vis/color-viz-series-03 - #77CBBF - durables / Home care
data vis/color-viz-series-04 - #667DBB - Nutrition
data vis/color-viz-series-06 - #B2F9FF - Catalog
data vis/color-viz-series-07 - #AF60B1 - Personal care
data vis/color-viz-series-08 - #F5A066 - Skin Care
data vis/color-viz-series-05 - #EF6D46 - Unknown

// light
data vis/color-viz-series-01 - #5969D6 - Beauty
data vis/color-viz-series-02 - #F3596C - Other
data vis/color-viz-series-03 - #396E75 - durables / Home care
data vis/color-viz-series-04 - #38539A - Nutrition
data vis/color-viz-series-06 - #05A896 - Catalog
data vis/color-viz-series-07 - #7E3E80 - Personal care
data vis/color-viz-series-08 - #F5A066 - Skin Care
data vis/color-viz-series-05 - #CE4800 - Unknown
*/
const THEME_STYLE = {
  light: {
    axis: "#555",
    grid: "#E0E0E0",
    tooltipBg: "#fff",
    tooltipText: "#000",
    pillText: "#2c2c2c",
    pillBorder: "#ccc"
  },
  dark: {
    axis: "#BFBFBF",
    grid: "#444",
    tooltipBg: "#1F1F1F",
    tooltipText: "#fff",
    pillText: "#D8D8D9",
    pillBorder: "#555"
  }
};

const BusinessLineMonthlyView: React.FC<BusinessLineMonthlyViewProps> = ({
  tableData,
  kpiCode,
}) => {
  const { t } = useTranslation();

  return isEmpty(tableData) ? (
    <div className={styles.no_data}>{t("noDataAvailable")}</div>
  ) : (
    <GenericTable
      tableData={tableData}
      kpiCode={kpiCode}
      highlightColumns={[]}
    />
  );
};

// ---- Sub-components for Views ---- //
interface BusinessLineYearlyViewProps {
  viewMode: ViewMode;
  tableData: any;
  stackedBarChartData?: any;
  kpiCode: string;
}

const BusinessLineYearlyView: React.FC<BusinessLineYearlyViewProps> = ({
  viewMode,
  tableData,
  stackedBarChartData,
  kpiCode
}) => {
  const { t } = useTranslation();
  const currentTheme: any = useAppSelector(
    (state: any) => state.theme.currentTheme
  );
  if (viewMode === "left") {
    return isEmpty(stackedBarChartData) ? (
      <div className={styles.no_data}>{t("noDataAvailable")}</div>
    ) : (
      <StackedGroupedBarChart
        data={stackedBarChartData}
        showPills={true}
        theme={currentTheme}
        THEME_STYLE={THEME_STYLE}
        CATEGORY_COLORS={CATEGORY_COLORS}
        ALL_PILL_COLOR={ALL_PILL_COLOR}
        isShowAllPill={true}
      />
    );
  }

  return isEmpty(tableData) ? (
    <div className={styles.no_data}>{t("noDataAvailable")}</div>
  ) : (
    <GenericTable
      tableData={tableData}
      kpiCode={kpiCode}
      highlightColumns={[1, 3]}
    />
  );
};
export const BusinessLineDetails: React.FC<{
  kpiCode?: string;
  onClose?: () => void;
}> = ({ kpiCode = "business-line", onClose }) => {
  const { affiliateCode, aboNumber } = useProfileParams();
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState<ViewMode>("left");
  const [aiContent, setAiContent] = useState<string>("");
  const [periodCode, setPeriodCode] = useState<string>("monthly");

  const isLoadingAiSummary = false;
  const detailData: any = periodCode === "monthly" ? businessLineMonthly : periodCode === "yearly" ? BusinessMockDetailYearly : []; // replace with API when BE ready

  const tableData = detailData?.detail?.chart?.chartDetail?.tableDetail;
  const yearlyStackedData = detailData?.detail?.chart?.chartDetail?.stackedBarChartDetail;
  type View = "perfYear" | "monthly" | "yearly";

  const viewMap: Record<View, JSX.Element> = {
    perfYear: <CategoryPerformanceView viewType="chart" title="Performance Year" showTabs={true} />,
    monthly: <BusinessLineMonthlyView tableData={tableData} kpiCode={"business-line"} />,
    yearly: <BusinessLineYearlyView viewMode={viewMode}
      tableData={tableData}
      stackedBarChartData={yearlyStackedData}
      kpiCode={kpiCode} />,
  };

  const perfYear = "PY 25";
  const periodItems = useMemo(
    () => [
      { code: "perfYear", label: perfYear },
      { code: "monthly", label: t("monthly_view") },
      { code: "yearly", label: t("yearly_view") },
    ],
    [t]
  );

  const headerContent = (
    <div className={styles.header_content}>
      <div className={styles.tile_header}>
        <div className={styles.title}>{t("businessline.title")}</div>
        <div className={styles.desc}>{t("businessline.description")}</div>
      </div>
      <div className={styles.chart_view_wrapper}>
        <ViewModeSwitcher
          mode={viewMode}
          onChangeMode={setViewMode}
          disabled={false}
          showSwitch={periodCode === 'yearly'}
          selectedTimeRangeCode={periodCode}
          onSelectTimeRange={setPeriodCode}
          timeRanges={periodItems}
        />
      </div>
      {periodCode !== "perfYear" && (
        <div className={styles.tile_header}>
          <div className={styles.title} style={{ fontSize: "16px" }}>
            {periodCode === "yearly" ? t("businessline.businessLineYearlySubtitle") : t("businessline.businessLineMonthlySubtitle")}
          </div>
          <div className={styles.desc} style={{ fontSize: "12px" }}>
            {t("businessline.businessLineMonthlySubHeader")}
          </div>
        </div>
      )}
    </div>
  );

  const leftContent = viewMap[periodCode as View] ?? null;

  const rightContent = isLoadingAiSummary ? (
    <Skeleton height="200px" />
  ) : (
    <InsightAI
      updateDate=""
      content={aiContent}
      title={t("ai_summary")}
      showDropdown={false}
      isDropdownEnabled={true}
      flowerIconSize={24}
      titleSize={14}
    />
  );

  return (
    <KPIDetailTile
      headerContent={headerContent}
      leftContent={leftContent}
      rightContent={rightContent}
      onClose={onClose!}
      dataTestId="business-line-detail"
    />
  );
};

export default BusinessLine;
